export type MissingProfileOutcome = 'needs-registration' | 'account-missing';

export function classifyMissingProfile({
  clerkRole,
}: {
  clerkRole: unknown;
}): MissingProfileOutcome {
  return typeof clerkRole === 'string' && clerkRole.length > 0
    ? 'account-missing'
    : 'needs-registration';
}

export function claimScopedAttempt(
  attemptedScopeId: string | null,
  scopeId: string
): { shouldAttempt: boolean; attemptedScopeId: string } {
  return {
    shouldAttempt: attemptedScopeId !== scopeId,
    attemptedScopeId: scopeId,
  };
}

export function withAbortSignal<T>(promise: Promise<T>, signal: AbortSignal): Promise<T> {
  if (signal.aborted) {
    return Promise.reject(new DOMException('Aborted', 'AbortError'));
  }

  return new Promise<T>((resolve, reject) => {
    const handleAbort = () => reject(new DOMException('Aborted', 'AbortError'));
    signal.addEventListener('abort', handleAbort, { once: true });

    promise.then(resolve, reject).finally(() => {
      signal.removeEventListener('abort', handleAbort);
    });
  });
}
